import { mglGray } from '@/styles/designSystemColors';
import Icon from '../Icon';

export default function RSSButton({ link }: { link: string }) {
  return (
    <a
      className="fixed bottom-[66px] right-24 z-[997] flex h-14 w-14 cursor-pointer flex-row items-center justify-center rounded-[56px] bg-[#f37d00] text-center no-underline shadow-[0_2px_2px_0_rgba(0,0,0,.14),_0_3px_1px_-2px_rgba(0,0,0,.12)] transition-all duration-300 ease-ease hover:bg-mglGray800 phone:bottom-6"
      href={link}
      style={{ color: mglGray.mglGray50 }}>
      <div className="flex items-center justify-center text-2xl">
        <Icon icon="mdi:rss" width={24} height={24} />
      </div>
    </a>
  );
}
